import React, { memo } from "react";
import { useSelector } from "react-redux";

import { CallItemComponent } from "./call-item.component";
import styles from "./call-list.module.scss";

import { selectCallIds } from "~/app/selectors/calls";

export const CallListComponent: React.FC = memo(() => {
  const callIds: string[] = useSelector(selectCallIds);

  return (
    <div className={styles.callList}>
      {callIds.map(id => (
        <CallItemComponent key={id} id={id} />
      ))}
    </div>
  );
});

CallListComponent.displayName = "CallListComponent";
